var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNatgeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.42 65.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdbdbd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NatGeoLogo72") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-NationalGeographic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NatGeoLogo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.2,0,46,.14l-.2,65.65L0,65.65ZM39.37,6.73,6.78,6.63,6.62,59.06l32.59.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.72,29h-3c-3.84-5.46-7.65-10.9-11.46-17h0l-.05,17H59l.08-23.7H62c3.85,5.43,7.66,10.82,11.43,16.93h.07l.05-16.9h3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.47,19.63c1-3.11,1.91-6,2.77-9.65h.07c.94,3.67,1.78,6.55,2.65,9.67Zm1.6-14.32L77.8,29h3.53l2.08-6.46,7.15,0L92.4,29l4.54,0L89.46,5.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "100.77 29.06 100.83 8.54 94.6 8.52 94.61 5.34 111.14 5.39 111.13 8.56 104.89 8.55 104.83 29.07 100.77 29.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 102.58,
    y: 15.23,
    width: 23.71,
    height: 4.03,
    transform: "translate(96.85 131.63) rotate(-89.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129,26.17c-4.23,0-5.7-4.7-5.69-9.23,0-4.37,1.72-8.53,5.75-8.52s5.71,4.18,5.7,8.55c0,4.54-1.52,9.21-5.76,9.2m0,3.38c6.2,0,10.08-5.49,10.11-12.56,0-6.64-4.24-11.94-10-12s-10.08,5.25-10.1,11.9c0,7.07,3.83,12.6,10,12.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.22,29.24h-2.94c-3.85-5.46-7.66-10.89-11.46-17h0l-.05,17-3.25,0,.07-23.7h2.95c3.84,5.43,7.66,10.82,11.43,16.93H156l.05-16.9h3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167,19.89c1-3.12,1.91-6,2.77-9.65h.07c.94,3.66,1.77,6.54,2.64,9.66Zm1.6-14.33-8.27,23.68h3.52l2.09-6.46,7.14,0,1.84,6.48h4.55L172,5.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "180.7 5.6 184.74 5.61 184.67 26.14 192.7 26.16 192.69 29.34 180.63 29.3 180.7 5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.16,48.81l0,9.79A18.6,18.6,0,0,1,67.38,60C60.41,60,56,54.58,56,47.61c0-6.47,4.44-12.11,11.56-12.09a10.17,10.17,0,0,1,5.75,1.84L72,40.17a8.88,8.88,0,0,0-4.33-1.27c-4.34,0-7.3,3.4-7.31,8.79,0,5.62,3.36,9,6.85,9a5.83,5.83,0,0,0,2.84-.57l0-7.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "88.72 39.17 81.94 39.15 81.92 45.66 88.56 45.68 88.55 48.86 81.91 48.84 81.89 56.49 89.88 56.51 89.87 59.7 77.82 59.66 77.89 35.96 88.73 35.99 88.72 39.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.2,56.76c-4.24,0-5.71-4.7-5.7-9.24,0-4.36,1.72-8.52,5.75-8.51s5.71,4.18,5.7,8.55c0,4.54-1.52,9.21-5.75,9.2m0,3.38c6.19,0,10.07-5.49,10.09-12.57,0-6.64-4.23-11.93-10-12s-10.07,5.25-10.1,11.89c0,7.08,3.83,12.61,10,12.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.79,49l0,9.79A19,19,0,0,1,124,60.21c-7,0-11.36-5.46-11.34-12.43,0-6.47,4.44-12.11,11.55-12.09A10.18,10.18,0,0,1,130,37.54l-1.33,2.81a8.72,8.72,0,0,0-4.34-1.27c-4.33,0-7.29,3.4-7.3,8.78,0,5.62,3.35,9,6.84,9a6.09,6.09,0,0,0,2.85-.57l0-7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.61,39.33h1.79c2.41,0,3.76,1.4,3.75,3.84,0,3.18-2,4.6-3.87,4.69-.41,0-1.36.07-1.7.1Zm10.23,20.55L144.1,50a8,8,0,0,0,4.12-7c0-4.61-2.79-6.86-7.33-6.87l-6.34,0-.07,23.7,4.06,0,0-8.94h1.83l3.8,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.58,50.52c.95-3.11,1.91-6,2.77-9.64h.07c.93,3.66,1.77,6.54,2.64,9.66Zm1.6-14.32-8.27,23.68h3.52l2.09-6.46,7.14,0,1.85,6.47,4.54,0-7.49-23.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.39,60h-4.06l.08-23.7,6.33,0c4.54,0,7.34,2.25,7.33,6.86a7.75,7.75,0,0,1-7.82,7.9h-1.89v-3c.21,0,1.32-.07,1.76-.1,1.94-.1,3.87-1.51,3.88-4.69,0-2.44-1.34-3.83-3.71-3.84h-1.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.85 60.04 197.78 60.03 197.82 48.62 189.38 48.59 189.35 60 185.32 59.99 185.39 36.29 189.42 36.3 189.39 45.41 197.83 45.43 197.85 36.39 201.92 36.4 201.85 60.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 195.94,
    y: 46.19,
    width: 23.71,
    height: 4.03,
    transform: "translate(158.97 255.86) rotate(-89.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.12,40.71A8.75,8.75,0,0,0,224,39.38c-4.13,0-7.16,3.4-7.18,8.78,0,5.63,3.3,9,7.23,9A7.64,7.64,0,0,0,228.07,56l1.11,2.95a10.28,10.28,0,0,1-5.35,1.6c-7,0-11.37-5.45-11.35-12.42C212.5,41.62,216.89,36,224,36a10,10,0,0,1,5.45,1.84Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatgeo);
export default __webpack_public_path__ + "static/media/natgeo.ff212bfe35fb8c2694558cb15c6f6899.svg";
export { ForwardRef as ReactComponent };